import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const otherForms = {
  id: 'other-forms',

  getDocumentRequestNotificationProps: (docCount, selectedPrinterName) => ({
    title: <FormattedMessage {...messages.printingOtherFormsTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.sentToPrinter} values={{ selectedPrinterName }} />,
  }),
};
